<template lang="pug">
  div
    el-dialog(
      title='Visualizar solicitação'
      :visible.sync='showModal'
       width='60%'
    )
      span.title Dados pessoais
      .divider
      el-row(:gutter='20')
        el-col(:span='12')
          span.label CPF:
          span {{ solicitacao.credenciado.pessoa.cpfCnpj }}
        el-col(:span='12')
          span.label E-mail:
          span {{ solicitacao.credenciado.pessoa.email }}

      el-row.marginBottom60(:gutter='20')
        el-col.paddingTop20(:span='12')
          span.label Nome:
          span {{ solicitacao.credenciado.pessoa.nomeRazaoSocial }}
        el-col.paddingTop20(:span='12')
          span.label Telefone:
          span {{ solicitacao.credenciado.pessoa.telefones[0].numero }}
            span(v-if='solicitacao.credenciado.pessoa.telefones.length > 1') ,&nbsp
          div.tel(v-for='(item, index) in solicitacao.credenciado.pessoa.telefones' :key='index' v-if="index > 0") {{ item.numero }}
            span(v-if='index != solicitacao.credenciado.pessoa.telefones.length - 1') ,&nbsp

      span.title.paddingTop40 Dados do credenciado
      .divider
      el-row(:gutter='20')
        el-col(:span='12')
          span.label Registro no conselho:
          span {{ solicitacao.credenciado.codigoCrea }}
        el-col(:span='12')
          span.label Formação:
          span {{this.formacao}}
      el-row.marginBottom60(:gutter='20')
        el-col.paddingTop20(:span='12' v-if="solicitacao.edital.tipoEdital === 'GEOMENSOR'")
          span.label Código de credenciamento do INCRA:
          span {{ solicitacao.credenciado.codigoIncra }}

      span.title Endereço
      .divider
      el-row(:gutter='20')
        el-col(:span='12')
          span.label Logradouro:
          span {{ solicitacao.credenciado.pessoa.endereco.logradouro }}
        el-col(:span='12')
          span.label Número:
          span {{ solicitacao.credenciado.pessoa.endereco.numero || '-' }}

      el-row(:gutter='20')
        el-col.paddingTop20(:span='12')
          span.label Bairro:
          span {{ solicitacao.credenciado.pessoa.endereco.bairro }}
        el-col.paddingTop20(:span='12')
          span.label Complemento:
          span {{ solicitacao.credenciado.pessoa.endereco.complemento || '-' }}

      el-row(:gutter='20')
        el-col.paddingTop20(:span='12')
          span.label CEP:
          span {{ solicitacao.credenciado.pessoa.endereco.cep || '-' }}
        el-col.paddingTop20(:span='12')
          span.label UF:
          span {{ solicitacao.credenciado.pessoa.endereco.uf || '-' }}

      el-row.marginBottom60(:gutter='20')
        el-col.paddingTop20(:span='12')
          span.label Município:
          span {{ solicitacao.credenciado.pessoa.endereco.municipio.nome }}

      span.title Documentos
      .divider
      el-table.table.marginBottom60(
        :data="solicitacao.credenciado.documentos"
      )
        template(slot="empty") Não foram encontradas solicitações com os dados informados
        el-table-column(
          label='Tipo de documento'
          prop='tipoDocumento.descricao'
        )
        el-table-column(
          label='Anexos'
        )
          template(slot-scope='scope')
            el-tooltip(
              v-if='scope.row.nome.length > 45'
              :content="scope.row.nome"
            )
              span {{ scope.row.nome.substring(0, 45) + '...' }}
            span(v-else) {{ scope.row.nome }}
        el-table-column(
          width="100"
          label="Ações"
        )
          template(slot-scope='scope')
            .flex
              app-action-button(
                icone="fas fa-download",
                @click="getDownload(scope.row)",
                cor="#666666",
                text="Baixar Documento"
              )

      span.title Status da solicitação: {{situacaoFormatada}}
      .divider
      el-row.marginBottom60(:gutter='20' v-if="isRejeitado")
        el-col.paddingTop20(:span='24')
          .justificativa-container
            span.justificativa {{solicitacao.justificativa}}

</template>
<script>
import AppActionButton from '@/components/AppActionButton'
import { findByCaminho } from '@/services/documentoService';
import FileSaver from 'file-saver';
import situacoes, { SITUACOES_FORMATADAS } from '@/constants/situacoes';

export default {
  props: {
    solicitacao: {
      type: Object,
      required: true,
    },
    modalOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showModal: {
      get() {
        return this.modalOpen;
      },
      set() {
        this.$emit('close-modal');
      }
    }
  },
  mounted() {
    this.isRejeitado = this.solicitacao.situacao === situacoes.REJEITADO;
    if (this.solicitacao.edital.tipoEdital === 'GEOMENSOR') {
      this.formacao = this.solicitacao.credenciado.formacao
    } else {
      this.formacao = this.solicitacao.credenciado.formacaoVistoriador
    }
  },
  components: {
    AppActionButton,
  },
  data() {
    return {
      isRejeitado: false,
      situacaoFormatada: SITUACOES_FORMATADAS[this.solicitacao.situacao],
      formacao: ''
    }
  },
  methods: {
    async getDownload (documento) {
      const resp = await findByCaminho(documento.caminho);
      const file = new Blob([resp])
      FileSaver.saveAs(file, documento.nome)
    },
  },
}
</script>
<style lang="scss" scoped>
.divider {
  border: 1px solid #dfe4ed;
  margin-bottom: 10px;
  margin-top: 10px;
}

.title {
  font-weight: bold;
  font-size: 16px;
  padding-left: 10px;
}

.label {
  font-weight: bold;
  font-size: 15px;
  padding-left: 10px;
}

.paddingTop20 {
  padding-top: 20px;
}

.marginBottom60 {
  margin-bottom: 60px;
}

.tel {
  padding-left: 10px;
}

.justificativa-container {
  display: flex;
  border: 1px solid black;
  width: 100%;
  min-height: 40px;
}

.justificativa {
  margin: 10px;
}
</style>
